<template>
  <div>
    <FeedbackButton
      feedback-value="like"
      :active-feedback-value="activeThumb"
      @updated="setActiveThumb('like')"
      icon-name="thumb_up"
      tooltip-hover-text="I like this content."/>

    <FeedbackButton
      feedback-value="dislike"
      :active-feedback-value="activeThumb"
      @updated="setActiveThumb('dislike')"
      icon-name="thumb_down"
      tooltip-hover-text="I don't like this content."/>

    <FeedbackButton
      feedback-value="flag"
      :active-feedback-value="activeFlag"
      @updated="toggleActiveFlag"
      icon-name="flag"
      tooltip-hover-text="This content is harmful."/>
  </div>
</template>

<script>
import FeedbackButton from '@/components/FeedbackButton.vue';

export default {
  name: 'FeedbackButtons',
  components: {FeedbackButton},
  data() {
    return {
      activeThumb: '',
      activeFlag: '',
      submittedFeedback: []
    }
  },
  props: {
    eventData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    setActiveThumb(newActive) {
      if (newActive !== this.activeThumb) {
        this.activeThumb = newActive
      } else {
        this.activeThumb = ''
      }
      this.processFeedback()
    },
    toggleActiveFlag() {
      if (!this.activeFlag) {
        this.activeFlag = 'flag'
      } else {
        this.activeFlag = ''
      }
      this.processFeedback()
    },
    processFeedback() {
      setTimeout(() => {
        if (this.activeThumb) {
          this.submitFeedback(this.activeThumb)
        }
        if (this.activeFlag) {
          this.submitFeedback(this.activeFlag)
        }
      }, 5000)
    },
    submitFeedback(feedback) {
      if (!this.submittedFeedback.includes(feedback)) {
        this.$sendEvent(`Submitted Feedback: ${feedback}`, this.eventData)
        this.submittedFeedback.push(feedback)
      }
    },
  },
}
</script>
